<ng-container [formGroup]="formGroup">

    <form-field dialog label="cards.settings.product_management_settings.brands_edit.label.is_private_label" [readonly]="!canEdit">
      <slide-toggle toggle [formGroup]="formGroup" for="isPrivateLabel"></slide-toggle>
      <validation-errors for="isPrivateLabel"></validation-errors>
    </form-field>
    
</ng-container>